export type MfaRedirectTarget = '/mfa' | '/verify-email' | null;

type MfaRedirectArgs = {
  emailVerified: boolean;
  hasSkippedMfaPrompt: boolean;
  mfaPrompt: boolean;
  mfaRequired: boolean;
};

export const getMfaRedirectTarget = ({
  emailVerified,
  hasSkippedMfaPrompt,
  mfaPrompt,
  mfaRequired,
}: MfaRedirectArgs): MfaRedirectTarget => {
  const wantsMfaRedirect =
    mfaRequired || (mfaPrompt && hasSkippedMfaPrompt === false);

  if (!wantsMfaRedirect) return null;

  return emailVerified ? '/mfa' : '/verify-email';
};
